var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormControlMixin } from '@open-wc/form-control';
import { submit } from '@open-wc/form-helpers';
import { property, state, query } from '@horizon/base/decorators.js';
import { defaultValidators } from './validators.js';
import 'element-internals-polyfill';
export const VALIDITY_PROPS = [
    'type',
    'value',
    'required',
    'min',
    'max',
    'minlength',
    'maxlength',
    'step',
    'pattern'
];
export function TextInputMixin(SuperClass) {
    var _HorizonTextInputMixin_instances, _HorizonTextInputMixin_initialValiditySet, _HorizonTextInputMixin_onInvalid, _HorizonTextInputMixin_onKeydown;
    class HorizonTextInputMixin extends FormControlMixin(SuperClass) {
        static get formControlValidators() {
            return [
                ...defaultValidators
            ];
        }
        constructor() {
            super();
            _HorizonTextInputMixin_instances.add(this);
            /**
             * @private
             */
            _HorizonTextInputMixin_initialValiditySet.set(this, false);
            /**
             * @private
             * Sets an initial default value for the purpose of checking whether or not to run validations
             * Mostly will default to '', but in currency inputs could be reset to '$' so that validations don't get run when
             * for optional inputs when the value === '$'
             */
            this.defaultInitialValue = '';
            /**
             * Sets the input value
             */
            this.value = '';
            /**
             * Set whether or not the input is required to have a value
             */
            this.required = false;
            /**
             * Set the input to be disabled
             */
            this.disabled = false;
            /**
             * Set the input to be disabled
             */
            this.readonly = false;
            /**
             * Set the help text for the input
             */
            this.helperText = '';
            /**
             * Hides the help text for the input
             */
            this.hideHelperText = false;
            /**
             * @private
             */
            _HorizonTextInputMixin_onInvalid.set(this, (event) => {
                var _a;
                event.preventDefault();
                (_a = this.validationTarget) === null || _a === void 0 ? void 0 : _a.focus();
            });
            this.addEventListener('keydown', __classPrivateFieldGet(this, _HorizonTextInputMixin_instances, "m", _HorizonTextInputMixin_onKeydown));
            this.addEventListener('invalid', __classPrivateFieldGet(this, _HorizonTextInputMixin_onInvalid, "f"));
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener('keydown', __classPrivateFieldGet(this, _HorizonTextInputMixin_instances, "m", _HorizonTextInputMixin_onKeydown));
            this.removeEventListener('invalid', __classPrivateFieldGet(this, _HorizonTextInputMixin_onInvalid, "f"));
        }
        /**
         * @private
         */
        get showErrors() {
            // only show the clear button if clearable, with a value
            // and not disabled or readonly
            return this.showError && !this.disabled && !this.readonly;
        }
        /**
         * @private
         */
        validationMessageCallback(message) {
            this.internalErrorMessage = message;
        }
        /**
         * @private
         */
        updated(changed) {
            // only run this validity set one time after the initial component render
            if (VALIDITY_PROPS.some((prop) => changed.has(prop))) {
                this.setValue(this.value);
            }
        }
        /** Sets focus on the input. */
        focus(options) {
            this.validationTarget.focus(options);
        }
        /** Removes focus from the input. */
        blur() {
            this.validationTarget.blur();
        }
    }
    _HorizonTextInputMixin_initialValiditySet = new WeakMap(), _HorizonTextInputMixin_onInvalid = new WeakMap(), _HorizonTextInputMixin_instances = new WeakSet(), _HorizonTextInputMixin_onKeydown = function _HorizonTextInputMixin_onKeydown(event) {
        const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        // Pressing enter when focused on an input should submit the form like a native input
        if (event.code === 'Enter' && !hasModifier) {
            if (this.form) {
                submit(this.form);
            }
        }
    };
    __decorate([
        state()
    ], HorizonTextInputMixin.prototype, "internalErrorMessage", void 0);
    __decorate([
        query('input')
    ], HorizonTextInputMixin.prototype, "validationTarget", void 0);
    __decorate([
        query('input')
    ], HorizonTextInputMixin.prototype, "innerInput", void 0);
    __decorate([
        property({ type: String, attribute: 'display-name' })
    ], HorizonTextInputMixin.prototype, "displayName", void 0);
    __decorate([
        property({ attribute: false })
    ], HorizonTextInputMixin.prototype, "errorMessages", void 0);
    __decorate([
        property({ attribute: false })
    ], HorizonTextInputMixin.prototype, "validation", void 0);
    __decorate([
        property()
    ], HorizonTextInputMixin.prototype, "name", void 0);
    __decorate([
        property({ type: String, reflect: true })
    ], HorizonTextInputMixin.prototype, "value", void 0);
    __decorate([
        property({ type: Boolean, reflect: true })
    ], HorizonTextInputMixin.prototype, "required", void 0);
    __decorate([
        property({ type: Boolean, reflect: true })
    ], HorizonTextInputMixin.prototype, "disabled", void 0);
    __decorate([
        property({ type: Boolean, reflect: true })
    ], HorizonTextInputMixin.prototype, "readonly", void 0);
    __decorate([
        property({ type: String, attribute: 'helper-text' })
    ], HorizonTextInputMixin.prototype, "helperText", void 0);
    __decorate([
        property({ type: Boolean, attribute: 'hide-helper-text' })
    ], HorizonTextInputMixin.prototype, "hideHelperText", void 0);
    __decorate([
        property({ type: Number })
    ], HorizonTextInputMixin.prototype, "minlength", void 0);
    __decorate([
        property({ type: Number })
    ], HorizonTextInputMixin.prototype, "maxlength", void 0);
    __decorate([
        property()
    ], HorizonTextInputMixin.prototype, "min", void 0);
    __decorate([
        property()
    ], HorizonTextInputMixin.prototype, "max", void 0);
    __decorate([
        property({ type: Number })
    ], HorizonTextInputMixin.prototype, "step", void 0);
    __decorate([
        property()
    ], HorizonTextInputMixin.prototype, "pattern", void 0);
    return HorizonTextInputMixin;
}
//# sourceMappingURL=text-input-mixin.js.map